module.exports = "/packs/benefits-of-challenging-she-creators-image-ad4f3bf6ced03592f5bce8c3a25a689c.png";